import { render } from "./Spinner.vue?vue&type=template&id=2ccdbea3"
import script from "./Spinner.vue?vue&type=script&lang=js"
export * from "./Spinner.vue?vue&type=script&lang=js"

import "./Spinner.vue?vue&type=style&index=0&id=2ccdbea3&lang=css"
script.render = render

export default script